<template>
    <CHeader with-subheader>
        <CToggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
        <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />

        <CHeaderBrand class="mx-auto d-lg-none">
            <CImg class="c-sidebar-brand-full p-2 mx-auto" :src="logo"
                style="width: 60% !important; background: #106f44" fluidGrow />
        </CHeaderBrand>
        <CBreadcrumbRouter class="border-0 m-1" />

        <div class="d-flex align-items-center my-auto">
            <span v-if="ap_po_date.ap_start && ap_po_date.ap_end" class="">AP Date:</span>
            <div class="d-flex flex-column align-items-center">
                <span v-if="ap_po_date.ap_start && ap_po_date.ap_end" class="pr-4 pl-1"><strong>{{ ap_po_date.ap_start }}</strong> - <strong>{{ ap_po_date.ap_end }}</strong></span>
                <span v-if="ap_po_date.ap_note" style="font-size: 12px;">{{ ap_po_date.ap_note }}</span>
            </div>
            
            <span v-if="ap_po_date.po_start && ap_po_date.po_end" class="">PO Date: </span>
            <div class="d-flex flex-column align-items-center">
                <span v-if="ap_po_date.po_start && ap_po_date.po_end" class="pl-1"><strong>{{ ap_po_date.po_start }}</strong> - <strong>{{ ap_po_date.po_end }}</strong></span>
                <span v-if="ap_po_date.po_note" style="font-size: 12px;">{{ ap_po_date.po_note }}</span>
            </div>
        </div>
        <CHeaderNav class="d-md-down-none ml-auto">
            <CBadge color="info" style="font-size: 12px" class="mr-2">{{
                getClientName
                }}</CBadge>
            <CBadge color="primary" style="font-size: 12px">{{
                getRoleName
                }}</CBadge>
            <TheHeaderDropdownNotif />
            <TheHeaderDropdownAccnt />
        </CHeaderNav>
        <CHeaderBrand class="h-100">
            <CImg class="c-sidebar-brand-full p-2 mx-auto w-auto h-100" :src="logo" style="background: #106f44"
                fluidGrow />
        </CHeaderBrand>
    </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import TheHeaderDropdownNotif from "./TheHeaderDropdownNotif";
import TheHeaderDropdownTasks from "./TheHeaderDropdownTasks";
import TheHeaderDropdownMssgs from "./TheHeaderDropdownMssgs";
import { storeData } from "../store";
import logo from "../assets/images/logo.svg";

import { mapState } from 'vuex';

export default {
    name: "TheHeader",
    data() {
        return {
            logo,
        };
    },
    components: {
        TheHeaderDropdownAccnt,
        TheHeaderDropdownNotif,
        TheHeaderDropdownTasks,
        TheHeaderDropdownMssgs,
    },
    methods: {
        checkNull(v) {
            if (v == null) {
                return ''
            } else return v
        }
    },
    computed: {

        ...mapState(['ap_po_date']),

        getRoleName() {
            if (storeData.currentUserDetails.role.name === "sys_admin")
                return "System Admin";
            else if (storeData.currentUserDetails.role.name === "client_admin")
                return "Client Admin";
            else if (storeData.currentUserDetails.role.name === "client_user")
                return "Client User";
            else if (storeData.currentUserDetails.role.name === "group_admin")
                return "Group Admin";
        },
        getClientName() {
            if (storeData.currentUserDetails.client.name)
                return storeData.currentUserDetails.client.name;
            else return "";
        },
    },
};
</script>
<style scoped>
.header {
    position: relative;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    -ms-flex-wrap: wrap;
    -ms-flex-negative: 0;
    min-height: 56px;
}
</style>
